module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, _vm._l((_vm.data.circles), function(circle, index) {
    return _c('div', {
      class: [_vm.block] + '-circle'
    }, [_c('div', {
      class: [_vm.block] + '-content'
    }, [(circle.header) ? _c('div', {
      class: [_vm.block + '-header', {
        'm-fullHeader': circle.fullHeader
      }],
      domProps: {
        "innerHTML": _vm._s(circle.header)
      }
    }) : _vm._e(), _vm._v(" "), (circle.text) ? _c('div', {
      class: [_vm.block] + '-text',
      domProps: {
        "innerHTML": _vm._s(circle.text)
      }
    }) : _vm._e()])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2980df0a","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Circles.vue
// module id = 411
// module chunks = 0